import styled from "styled-components";

const Container = styled.div`
  position: fixed;
  top: ${(props) => 100 + props.index * 0}px;
  left: ${(props) => 100 + props.index * 400}px;
  width: 400px;
  max-width: calc(100vw - 40px);
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: ${(props) => 1000 + props.index};
  overflow: hidden;
  animation: slideIn 0.3s ease-out;

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
    width: 90vw;
    max-width: 350px;
    top: ${(props) => 100 + props.index * 20}px;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 32px;
  height: 32px;
  border: none;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 24px;
  line-height: 1;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  z-index: 10;

  &:hover {
    background: rgba(0, 0, 0, 0.7);
  }
`;

const Content = styled.div`
  padding: 20px;
  max-height: 500px;
  overflow-y: auto;

  @media (max-width: 768px) {
    max-height: 400px;
  }
`;

const Image = styled.div`
  width: 100%;
  margin-bottom: 15px;

  img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 8px;
  }
`;

const Description = styled.div`
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  word-break: break-word;

  p {
    margin: 0 0 10px 0;
  }

  a {
    color: #0066cc;
    text-decoration: underline;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  border-top: 1px solid #e0e0e0;
`;

const HideTodayButton = styled.button`
  flex: 1;
  padding: 15px;
  border: none;
  background: #f5f5f5;
  color: #666;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #e8e8e8;
  }
`;

const CloseTextButton = styled.button`
  flex: 1;
  padding: 15px;
  border: none;
  background: #333;
  color: white;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #555;
  }
`;

export {
  Container,
  CloseButton,
  Content,
  Image,
  Description,
  ButtonGroup,
  HideTodayButton,
  CloseTextButton,
};

export default {
  Container,
  CloseButton,
  Content,
  Image,
  Description,
  ButtonGroup,
  HideTodayButton,
  CloseTextButton,
};
